import { render, staticRenderFns } from "./BaseFormText.vue?vue&type=template&id=19193376&"
import script from "./BaseFormText.vue?vue&type=script&lang=js&"
export * from "./BaseFormText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports